import { render, staticRenderFns } from "./CustomFieldsSetting.vue?vue&type=template&id=40a68d8d&"
import script from "./CustomFieldsSetting.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_Lavoro\\ALCYON\\Homestead\\code\\reporting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40a68d8d')) {
      api.createRecord('40a68d8d', component.options)
    } else {
      api.reload('40a68d8d', component.options)
    }
    module.hot.accept("./CustomFieldsSetting.vue?vue&type=template&id=40a68d8d&", function () {
      api.rerender('40a68d8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/CustomFieldsSetting.vue"
export default component.exports